import type { ReactNode } from "react";
import { classNames } from "./internal/class-names";

export interface LoadingStateProps {
  /** Visible and announced progress text. */
  readonly label: ReactNode;
  readonly className?: string | undefined;
}

/** In-flight placeholder. The text is visible, not only a spinner. */
export function LoadingState({ className, label }: LoadingStateProps): ReactNode {
  return (
    <div
      aria-busy="true"
      className={classNames("thw-state", "thw-state--loading", className)}
      role="status"
    >
      <span aria-hidden="true" className="thw-button__busy" />
      <span className="thw-state__title">{label}</span>
    </div>
  );
}
